const utils = {
  /**
   * 
   * @param {String} str 
   * @param {String} splitStr 
   * @return {Array}
   */
  stringToArray(str, splitStr) {
    return str.split(splitStr)
  }
}


module.exports = utils



// WEBPACK FOOTER //
// ./src/utils/index.js